import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../mock';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('lbv_lang') || 'it');

  useEffect(() => {
    localStorage.setItem('lbv_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((p) => (p === 'it' ? 'en' : 'it'));

  const t = (key) => {
    const parts = key.split('.');
    let node = translations[lang];
    for (const p of parts) {
      node = node?.[p];
    }
    return node ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used within LanguageProvider');
  return ctx;
}
